var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.roundClearedNotif = function(progression) {
    
    var _this = this;
    EHDI.aka.Container.call(this);
    var overlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0x000000, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
    this.addChild(overlay);
    overlay.interactive = true;
    overlay.alpha = 0.5;
    
    var sprite = new EHDI.aka.Sprite(EHDI.Assets.images["cm_ui_matchpopup"]);
    sprite.anchor.set(0.5);
    sprite.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.5);
    this.addChild(sprite);
    
    var text = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_LEVELCOMPLETE"));
    var newText = EHDI.GAME.jsonManager.getLocale("STR_LEVELCOMPLETE").TEXT.split(" ");
    text.text = newText[0] +  " " + (progression) + " " + newText[1];
    text.anchor.set(0.5);
    sprite.addChild(text);
    
    var timeline = new TimelineMax();
    var addSparkles = function() {
        for(var i = 0; i < 11; i++) {
            var randSparkle = new EHDI.components.Sparkle();
            randSparkle.position.set(sprite.width * EHDI.NumberUtil.randomRange(-0.5, 0.5), sprite.height * EHDI.NumberUtil.randomRange(-0.5, 0.5)); 
            sprite.addChild(randSparkle);
            randSparkle.appear();
        }
    }
    
    timeline.from(sprite.scale, 0.5, {x : 0, y : 0, ease : Bounce.easeOut});
    timeline.addCallback(function() {
        EHDI.GAME.gameScene.scoreHolder.addScore(progression * 100);
        EHDI.GAME.soundManager.playSFX("bonus");
        addSparkles();
    });
    timeline.from(text, 0.25, {alpha : 0});
    timeline.to(this, 0.5, {alpha : 0}, "+=3");
    timeline.addCallback(function() {
        EHDI.GAME.bgm.play();
        EHDI.GAME.pauseButton.isPaused = false;
        _this.destroy({children : true});
        _this = null;
    });
}

EHDI.components.roundClearedNotif.prototype = Object.create(EHDI.aka.Container.prototype);